import moment from 'moment'

interface Persona {
  id: string
  gradoParentela: string
  cognome: string
  nome: string
  nascitaData: Date
  codiceFiscale: string
  flagDaAnagrafe: boolean
}

export type Option = { value: string; label: string }

export const ruoloOptions: Option[] = [
  { value: '', label: "-- Seleziona un'opzione --" },
  { value: '1', label: 'Intestatario' },
  { value: '2', label: 'Moglie/Marito' },
  { value: '3', label: 'Figlia/Figlio' },
  { value: '4', label: 'Nipote (discendente)' },
  { value: '5', label: 'Pronipote (discendente)' },
  { value: '6', label: 'Madre/Padre' },
  { value: '7', label: 'Nonna/Nonno' },
  { value: '8', label: 'Bisnonna/Bisnonno' },
  { value: '9', label: 'Sorella/Fratello' },
  { value: '10', label: 'Nipote (collaterale)' },
  { value: '11', label: 'Zia/Zio (collaterale)' },
  { value: '12', label: 'Cugina/Cugino' },
  { value: '13', label: 'Altro parente' },
  { value: '16', label: 'Nuora/Genero' },
  { value: '17', label: 'Suocera/Suocero' },
  { value: '18', label: 'Cognata/Cognato' },
  { value: '20', label: 'Nipote (affine)' },
  { value: '21', label: 'Zia/Zio (affine)' },
  { value: '22', label: 'Altro affine' },
  { value: '23', label: 'Convivente (con vincoli di adozione o affettivi)' },
  { value: '24', label: 'Responsabile della convivenza non affettiva' },
  { value: '25', label: 'Convivente in convivenza non affettiva' },
  { value: '99', label: 'Non definito/comunicato' },
  { value: '81', label: 'Nipote' },
  { value: '28', label: 'Unito civilmente' },
]

function getRuolo(value: string) {
  const option = ruoloOptions.find((o) => o.value === value)
  if (option) {
    return option.label
  }
  return value
}

const DatiAnagrafici: React.FC<{ persone: Persona[] }> = ({ persone }) => {
  const renderPersoneRows = (persone: Persona[]) => {
    return persone.map((persona) => {
      return (
        <tr key={persona.id}>
          <td className="p-2 border-inherit border-b border-solid text-left">
            {getRuolo(persona.gradoParentela)}
          </td>
          <td className="p-2 border-inherit border-b border-solid text-left">{persona.cognome}</td>
          <td className="p-2 border-inherit border-b border-solid text-left">{persona.nome}</td>
          <td className="p-2 border-inherit border-b border-solid text-left">
            {moment(persona.nascitaData).format('DD/MM/YYYY')}
          </td>
          <td className="p-2 border-inherit border-b border-solid text-left">
            {persona.codiceFiscale}
          </td>
          <td className="p-2 border-inherit border-b border-solid text-center">
            {persona.flagDaAnagrafe ? 'Sì' : 'No'}
          </td>
        </tr>
      )
    })
  }

  return (
    <div className="mt-4 border-solid bg-gray-100 rounded min-[576px]:p-6 min-[576px]:border overflow-x-auto mb-10">
      {persone.length > 0 && (
        <table className="min-[992px]:text-lg border-collapse align-top text-[#1a1a1a] mb-4 w-full">
          <thead className="align-bottom border-inherit border-solid border-0">
            <tr className="border-inherit border-solid border-0">
              <th scope="col" className="p-2 border-inherit border-b border-solid text-left">
                Parentela
              </th>
              <th scope="col" className="p-2 border-inherit border-b border-solid text-left">
                Cognome
              </th>
              <th scope="col" className="p-2 border-inherit border-b border-solid text-left">
                Nome
              </th>
              <th scope="col" className="p-2 border-inherit border-b border-solid text-left">
                Data di nascita
              </th>
              <th scope="col" className="p-2 border-inherit border-b border-solid text-left">
                Codice fiscale
              </th>
              <th scope="col" className="p-2 border-inherit border-b border-solid text-center">
                Anagrafe?
              </th>
            </tr>
          </thead>
          <tbody>{renderPersoneRows(persone)}</tbody>
        </table>
      )}
    </div>
  )
}

export default DatiAnagrafici
